// extracted by mini-css-extract-plugin
module.exports = {"readFull":"ShowMore_readFull__2UTsJ","itemsHolder":"ShowMore_itemsHolder__2P9Pt"};